import React, { useRef } from "react";
import heroVideo from "./assets/hero_video_main.mp4";
import SEOComponent from "./components/SEOComponent";
import OptimizedImage from "./components/OptimizedImage";
import { motion } from "framer-motion";
import Masonry from "@mui/lab/Masonry";
import Paper from "@mui/material/Paper";
import telcomImage from "../src/assets/telcom.jpg";
import proptechImage from "../src/assets/Prop-tech.jpg";
import banking from "../src/assets/banking1.avif";
import software from "../src/assets/software.avif";
import education from "../src/assets/education.avif";
import { styled } from "@mui/material/styles";

import backgroundImage4 from "../src/assets/background2.jpg";
import backgroundImage1 from "../src/assets/background4.jpg";
import healthCare from "../src/assets/healthCare.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Autoplay, Navigation } from "swiper/modules";
import Carouselcomponent from "./carousel";
import { Link } from "react-router-dom";

export default function Home() {
  const newsRef = useRef(null);
  const industries = [
    {
      title: "Telecom",
      icon: "📡",
      img: telcomImage,
      description: (
        <>
          From <u>5G deployment strategies to AI-powered customer analytics</u>,
          our consulting approach ensures operators achieve both operational
          efficiency and digital growth.
          <br />
          We <u>align business models with evolving market dynamics</u>,
          enabling telecom firms to move beyond connectivity and deliver
          value-added digital services.
        </>
      ),
      to: "/telecom",
      color: "blue",
    },
    {
      title: "Healthcare",
      icon: "🏥",
      img: healthCare,
      description: (
        <>
          <u>Focusing on enabling healthcare-centric digital transformation</u>,
          we help hospitals, payers, and life sciences companies harness
          technologies such as AI, IoT, and cloud to improve care outcomes,
          streamline operations, and ensure compliance.
          <br />
          From telemedicine platforms to predictive healthcare analytics, we{" "}
          <u>
            drive strategies that blend clinical excellence with operational
            efficiency
          </u>
          .
        </>
      ),
      to: "/healthcare",
      color: "green",
    },
    {
      title: "Banking & Finance",
      icon: "🏦",
      img: banking,
      description: (
        <>
          From digital banking transformation to AI-powered risk modeling, our
          consulting services address both <u> growth and governance </u>.<br />
          With fintech innovation and regulatory compliance shaping the future,
          we help BFSI organizations build{" "}
          <u> agile, scalable, and future-ready operating models </u> that
          balance profitability with trust and transparency.
        </>
      ),
      to: "/banking",
      color: "purple",
    },
    {
      title: "IT & Software",
      icon: "💻",
      img: software,
      description: (
        <>
          <div className="mb-2">
            With <u>speed, scalability, and innovation</u> as non-negotiable, we
            help IT and software enterprises reimagine product strategies,
            optimize delivery models, and harness next-generation technologies.
          </div>
          Our consulting expertise spans cloud adoption, DevOps transformation,
          platform engineering, and AI integration - ensuring{" "}
          <u>faster time-to-market and sustained competitiveness</u>
          <br />
          <br />
          We enable IT leaders to not just solve today’s challenges but also
          <u> anticipate tomorrow’s opportunities</u> in an evolving digital
          ecosystem.
        </>
      ),
      to: "/it-software",
      color: "pink",
    },
    {
      title: "Education",
      icon: "🎓",
      img: education,
      description: (
        <>
          We partner with academic institutions, EdTech firms, and training
          providers to <u> reimagine education for the digital-first era </u>.{" "}
          <br /> From deploying AI-powered learning platforms to creating smart
          campus ecosystems, we enable{" "}
          <u>immersive, personalized, and scalable learning experiences.</u> Our
          consulting approach helps education providers{" "}
          <u> blend pedagogy with technology</u>.
        </>
      ),
      to: "/education",
      color: "yellow",
    },
    {
      title: "PropTech",
      icon: "🏢",
      img: proptechImage, // make sure you have an appropriate image imported as `proptechImage`
      description: (
        <>
          We empower real estate and urban development players to
          <u> capitalize on PropTech innovations</u>. From smart city planning
          to digital twin adoption, we help orgs redefine how spaces are
          designed, built, and managed.
          <br />
          Our consulting focus includes{" "}
          <u>
            IoT-enabled asset management, AI-driven market insights, and
            sustainable urban strategies.
          </u>
          <br />
          We enable stakeholders - developers, investors, and city planners - to
          unlock efficiency, transparency, and{" "}
          <u>value creation across the property lifecycle.</u>
        </>
      ),
      to: "/proptech",
      color: "emerald", // or choose another Tailwind color like teal, indigo, etc.
    },
  ];
  const heights = [250, 300, 250, 350, 300, 350];

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "transparent", // <- you may have missed this
    ...theme.typography.body2,
    padding: theme.spacing(0.5),
    textAlign: "center",
    width: "100px",
    color: (theme.vars || theme).palette.text.secondary,
    ...theme.applyStyles("dark", {
      backgroundColor: "#1A2027",
    }),
  }));
  const cards = [
    {
      title: "🤖 AI Consulting",
      link: "/solutions/AIConsulting",
      points: [
        "AI Strategy - Development & Implementation",
        "Custom AI Development",
        "Generative AI Development & Services",
        "Agentic AI",
        "Ethical AI and Compliance",
        "AI Research & Training",
      ],
      content:
        "We enable organizations to leverage Artificial Intelligence not just as a technology but as a strategic enabler. Our approach blends AI engineering, ethics, and business alignment.",
    },
    {
      title: "📊 Business & Technology Consulting",
      link: "/solutions/business-technology",
      points: [
        "Microsoft Services",
        "Website Design & Development",
        "Cloud Solutions",
        "Cybersecurity",
        "Strategy & Digital Transformation",
        "Governance, Risk & Compliance",
      ],
      content:
        "We help enterprises optimize their digital backbone, making them agile, compliant, and customer-centric.",
    },
    {
      title: "📈 Digital Marketing",
      link: "/solutions/digital-marketing",
      points: [
        "Demand Generation & Sales Pipelines",
        "SEO",
        "Social Media Marketing (SMM)",
        "Email & Content Marketing",
        "Video Marketing",
        "Influencer Marketing",
      ],
      content:
        "We use data, creativity, and technology to power marketing that delivers measurable demand and brand equity.",
    },
  ];

  return (
    <div
      className="min-h-screen"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.3)), url(${backgroundImage1})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <SEOComponent
        title="AlifShams - AI Consulting, Digital Marketing & Technology Solutions"
        description="Transform your business with expert AI consulting, digital marketing, and technology solutions in Dubai, UAE. Specializing in AI strategy, SEO, social media marketing, cloud solutions, and digital transformation."
        keywords="AI consulting Dubai, digital marketing UAE, technology consulting Dubai, artificial intelligence UAE, SEO services Dubai, social media marketing UAE, cloud solutions Dubai, digital transformation UAE, business consulting Dubai, web development UAE,
        PropTech consulting, healthcare digital solutions, telecom business strategy"
        url="https://digitalif.net"
      />
      {/* Hero Section */}
      <div className="relative w-full h-[calc(100vh-73px)] mt-[73px]">
        <div className="absolute inset-0">
          <video
            className="h-full w-full object-fill"
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
            controls={false}
          >
            <source src={heroVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="relative z-10 flex h-full flex-col items-center justify-center bg-black/60 px-8 text-center">
          <h1
            data-aos="fade-right"
            className="mb-4 font-sans text-3xl font-extrabold text-white sm:text-4xl md:text-6xl lg:text-7xl"
          >
            <span className="text-6xl sm:text-8xl md:text-12xl lg:text-[200px] font-serif tracking-wide animate-pulse">
              <span className="text-white">
                A<span className="text-[#994AF9]">L</span>I
                <span className="text-[#994AF9]">F</span>
              </span>
            </span>
          </h1>
          <p
            data-aos="fade-left"
            className="mx-auto font-bold max-w-3xl text-sm text-white sm:text-lg md:text-xl lg:text-2xl px-4"
          >
            {/* Transforming ideas into reality through innovation and excellence */}
            CONNECT | CREATE | CONQUER
          </p>
          {/* <Link to="/solutions/AIConsulting/AIstrategy">
            <button className="mt-8 px-8 py-3 bg-[#B31F7E] text-white font-medium rounded-xl hover:bg-[#482A7A] transition-colors">
              Discover More
            </button>
          </Link> */}
        </div>
      </div>
      <div>
        <div>
          <Carouselcomponent />
        </div>

        <div data-aos="fade-up" className="relative">
          <section
            className="z-10 px-4 sm:px-6 md:px-10 pb-10"
            ref={newsRef}
            style={{
              // backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.3)), url(${domainsImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "repeat",
            }}
          >
            <div data-aos="fade-up" className="container mx-auto px-4 py-10 ">
              <h2 className="text-2xl sm:text-3xl md:text-4xl text-[#B31F7E] font-bold text-center mb-4">
                Our Domains
              </h2>
              <div className="w-24 h-1 bg-white mx-auto"></div>
            </div>
            <Swiper
              effect="coverflow"
              grabCursor={true}
              slidesPerView={1}
              centeredSlides={true}
              initialSlide={1}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop={true}
              loopedSlides={3}
              coverflowEffect={{
                rotate: 30,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }}
              breakpoints={{
                640: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
              }}
              modules={[EffectCoverflow, Autoplay, Navigation]}
            >
              {[...cards, ...cards].map((card, index) => {
                const gradients = [
                  "bg-gradient-to-br from-[#B31F7E] to-[#482A7A]",
                  "bg-gradient-to-br from-[#3B82F6] to-[#1E40AF]",
                  "bg-gradient-to-br from-[#10B981] to-[#047857]",
                ];
                return (
                  <SwiperSlide key={index}>
                    <div
                      className={`${
                        gradients[index % 3]
                      } text-white rounded-xl shadow-lg h-[400px] p-5 flex flex-col items-start justify-center text-left border border-gray-300`}
                    >
                      <h3 className="text-xl font-bold mb-3 uppercase">
                        {card.title}
                      </h3>
                      <p className="text-sm justify-center">{card.content}</p>
                      <br />
                      <ul className="list-disc ml-5 space-y-2 text-sm">
                        {card.points.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                      <Link to={card.link}>
                        <button className="mt-4 text-sm bg-white text-[#B31F7E] font-bold px-4 py-2 rounded hover:bg-purple-100 transition-all">
                          Know More →
                        </button>
                      </Link>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </section>
          <div
            style={{
              // backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.3)), url(${backgroundImage1})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "repeat",
            }}
          >
            <motion.section
              data-aos="fade-up"
              className="py-10 px-4 sm:px-6 md:px-10 lg:px-20 text-white w-full z-20 relative"
            >
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-4 text-[#B31F7E]">
                Industries
              </h2>
              <div className="w-24 h-1 bg-white mx-auto"></div>
              <Masonry
                columns={{ xs: 1, sm: 2, md: 3 }}
                spacing={2}
                defaultHeight={450}
                defaultColumns={1}
                defaultSpacing={1}
                sequential
                className="py-2"
              >
                {industries.map((item, index) => (
                  <Item
                    key={index}
                    sx={{
                      height: heights[index % heights.length],
                      boxShadow: "none",
                    }}
                  >
                    <div className="relative h-full w-full overflow-hidden cursor-pointer rounded-xl group flip-card">
                      <div className="flip-inner w-full h-full">
                        {/* Front */}
                        <div className="flip-front w-full h-full">
                          <OptimizedImage
                            src={item.img}
                            alt={item.title}
                            className="w-full h-full object-cover rounded-xl"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-80 z-10" />
                          <div className="absolute bottom-2 left-3 text-white font-semibold text-xl z-20 text-center">
                            {item.title}
                          </div>
                        </div>

                        {/* Back */}
                        <div
                          className={`flip-back flip-back-${index} w-full h-full rotate-y-180 absolute top-0 left-0 flex flex-col items-center text-white text-sm px-4 py-6`}
                        >
                          <h3 className="text-lg font-bold mb-4 text-white border-b-2 border-white">
                            {item.title}
                          </h3>
                          <div className="flex-1 flex items-start justify-center">
                            <p className="text-center mb-1 text-white">
                              {item.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Item>
                ))}
              </Masonry>
            </motion.section>
          </div>
        </div>
        <div
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.3)), url(${backgroundImage4})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "repeat",
          }}
        >
          <section className="py-16">
            <div className="container mx-auto px-4">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-4 text-[#B31F7E]">
                Why Alif?
              </h2>
              <div className="w-24 h-1 bg-white mx-auto mb-12"></div>

              <div className="relative flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12 max-w-6xl mx-auto px-4">
                {/* Benefits & Perks */}
                <div className="text-white text-left flex-1">
                  <ul className="text-gray-300 space-y-3 text-left inline-block">
                    <li className="group transition-transform duration-200 hover:translate-x-1 hover:text-white hover:bg-[#B31F7E] rounded-lg p-2">
                      <span className="mr-2 font-bold text-white">1.</span>
                      <strong className="text-[#B31F7E] group-hover:text-white">Technology Meets Vision</strong><br />
                      We merge innovation and intelligence with your brand’s goals to create impactful, results-driven solutions.
                    </li>
                    <li className="group transition-transform duration-200 hover:translate-x-1 hover:text-white hover:bg-[#B31F7E] rounded-lg p-2">
                      <span className="mr-2 font-bold text-white">2.</span>
                      <strong className="text-[#B31F7E] group-hover:text-white">Unified Ecosystem</strong><br />
                      From IT and AI consulting to digital marketing and event production — all under one roof for seamless integration.
                    </li>
                    <li className="group transition-transform duration-200 hover:translate-x-1 hover:text-white hover:bg-[#B31F7E] rounded-lg p-2">
                      <span className="mr-2 font-bold text-white">3.</span>
                      <strong className="text-[#B31F7E] group-hover:text-white">Human-Centered Innovation</strong><br />
                      Beyond data and code, we understand your audience, your brand emotion, and your purpose.
                    </li>
                    <li className="group transition-transform duration-200 hover:translate-x-1 hover:text-white hover:bg-[#B31F7E] rounded-lg p-2">
                      <span className="mr-2 font-bold text-white">4.</span>
                      <strong className="text-[#B31F7E] group-hover:text-white">Measurable Results</strong><br />
                      Every project is guided by data analytics and performance tracking to ensure tangible ROI.
                    </li>
                    <li className="group transition-transform duration-200 hover:translate-x-1 hover:text-white hover:bg-[#B31F7E] rounded-lg p-2">
                      <span className="mr-2 font-bold text-white">5.</span>
                      <strong className="text-[#B31F7E] group-hover:text-white">Collaborative Partnership</strong><br />
                      We work alongside you as a true partner, not just a service provider.
                    </li>
                  </ul>
                </div>

                {/* Vertical Line */}
                <div className="hidden md:block w-px h-96 bg-white"></div>

                {/* Career Opportunities */}
                <div className="text-white text-left flex-1">
                  <ul className="text-gray-300 space-y-3 text-left inline-block">
                    <li className="group transition-transform duration-200 hover:translate-x-1 hover:text-white hover:bg-[#B31F7E] rounded-lg p-2">
                      <span className="mr-2 font-bold text-white">6.</span>
                      <strong className="text-[#B31F7E] group-hover:text-white">Creative + Technical Expertise</strong><br />
                      Our team fuses design thinking with deep technical know-how to deliver powerful brand experiences.
                    </li>
                    <li className="group transition-transform duration-200 hover:translate-x-1 hover:text-white hover:bg-[#B31F7E] rounded-lg p-2">
                      <span className="mr-2 font-bold text-white">7.</span>
                      <strong className="text-[#B31F7E] group-hover:text-white">Scalable Solutions</strong><br />
                      Whether you're a startup or enterprise, our adaptive strategies evolve with your business.
                    </li>
                    <li className="group transition-transform duration-200 hover:translate-x-1 hover:text-white hover:bg-[#B31F7E] rounded-lg p-2">
                      <span className="mr-2 font-bold text-white">8.</span>
                      <strong className="text-[#B31F7E] group-hover:text-white">End-to-End Execution</strong><br />
                      We handle everything — from strategy and development to marketing and on-ground event execution.
                    </li>
                    <li className="group transition-transform duration-200 hover:translate-x-1 hover:text-white hover:bg-[#B31F7E] rounded-lg p-2">
                      <span className="mr-2 font-bold text-white">9.</span>
                      <strong className="text-[#B31F7E] group-hover:text-white">Future-Ready Approach</strong><br />
                      AI, automation, and data intelligence power everything we do — keeping your business ahead of the curve.
                    </li>
                    <li className="group transition-transform duration-200 hover:translate-x-1 hover:text-white hover:bg-[#B31F7E] rounded-lg p-2">
                      <span className="mr-2 font-bold text-white">10.</span>
                      <strong className="text-[#B31F7E] group-hover:text-white">Impact That Lasts</strong><br />
                      Our solutions go beyond visibility — they create engagement, transformation, and growth.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>
          <section
            className="py-16"
            // style={{
            //   backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.3)), url(${backgroundImage1})`,
            //   backgroundSize: "cover",
            //   backgroundPosition: "center",
            //   backgroundRepeat: "repeat",
            // }}
          >
            <div className="container mx-auto px-4 text-center">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 text-white">
                Ready to Transform Your Business?
              </h2>
              <div className="w-24 h-1 bg-white mx-auto mb-8"></div>
              <p className="text-lg sm:text-xl text-white mb-8 max-w-2xl mx-auto px-4">
                Join thousands of companies who trust ALIF to drive their
                digital transformation and achieve exceptional results.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center px-4">
                <Link to="/contact">
                  <button className="px-8 py-4 bg-white text-[#B31F7E] font-semibold rounded-xl hover:bg-gray-100 transition-colors">
                    Contact Us Now
                  </button>
                </Link>
                <Link to="solutions/AIConsulting">
                  <button className="px-8 py-4 border-2 border-white text-white font-semibold rounded-xl hover:bg-white hover:text-[#B31F7E] transition-colors">
                    Explore Services
                  </button>
                </Link>
              </div>
            </div>
          </section>
        </div>
      </div>
    
  );
}
